import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { IS_SERVER } from '@core/config';
import { HyphenatePipe } from '../hyphenate/hyphenate.pipe';
import { HtmlHelper } from '@lib/utils/helpers';

@Pipe({ name: 'sanitize', standalone: true })
export class SanitizePipe implements PipeTransform {
  static instance: SanitizePipe;

  private isServer = inject(IS_SERVER, { optional: true });
  private domSanitizer = inject(DomSanitizer);

  public transform(value: string = '', ...args: unknown[]): SafeHtml {
    value = HyphenatePipe.transform(value);

    if (this.isServer) {
      return this.domSanitizer.bypassSecurityTrustHtml(value);
    }

    const sanitized = HtmlHelper.sanitizeHtml(value);
    return this.domSanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
